import { Outlet } from 'react-router-dom'

const Feedback = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default Feedback
